
import '@trevoreyre/autocomplete-vue/dist/style.css';
import { LngLat } from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { initClient } from '../../api';
import { BasePoI, MapClient, POIQuery, POIQueryParam } from '../backend/backendapi';
import PageTitleBar from './PageTitleBar';
import MapWithMarkers from './MapWithMarkers';
import MarkerDetails from './MarkerDetails';

Vue.use(Toasted, { duration: 2000 });

const mapConfig = {
  center: [116.98, 36.67],
  zoom: 5,
  minZoom: 1,
  maxZoom: 20,
  // interactive: true,
  // attributionControl: true,
  customAttribution: '© Revotec',
  // bearingSnap: 7,
  scrollZoom: true,
  // maxBounds: [[-100, -90], [100, 90]],
  // boxZoom: true,
  // dragRotate: false,
  // dragPan: true,
};

@Component({
  name: 'Page',
  components: {
    MapWithMarkers,
    MarkerDetails,
    PageTitleBar,
  },
})
export default class Page extends Vue {
  readonly accessToken: string = 'pk.eyJ1IjoiaW5uYXlhdHVsbGFoIiwiYSI6ImNrN3JuOGdreDBheDQzbXFyajFhd254a2YifQ.1Lulh2KlK2wtfjLxy-BLtg';
  private style: string = 'streets-v11';
  readonly mapId: string = 'container';
  private mapPopup: any = undefined;
  readonly mapOptions = mapConfig;

  private readonly service: MapClient = initClient(MapClient);
  readonly pois: BasePoI[] = [];
  private poiQuery: POIQuery = new POIQuery({ param: new POIQueryParam() }); //hack contained in this.fetchPois() cause currently we only have 1 checkbox, html model bound on this.poiQuery.param.isUserPOIOnly
  selectedPoi: BasePoI | null = null;
  selectedPoiEdit = false;

  dateFrom: Date = new Date(Date.now() - 24 * 60 * 60 * 1000); //yesterday, same time 
  dateTo: Date = new Date(this.dateFrom.getTime() + 24 * 60 * 60 * 1000); //today, 1 day after dateFrom on the millisecond
  dateCurrent: Date = new Date(this.dateTo);

  get poisWithEdit(): BasePoI [] {
    const ret = [...this.pois];
    if (this.selectedPoi && !this.pois.find(e => e.id === this.selectedPoi!.id)) {
      ret.push(this.selectedPoi);
    }
    return ret;
  }

  get mapStyle(): string {
    return 'mapbox://styles/mapbox/' + this.style;
  }

  mounted() {
    this.fetchPois();
  }

  //#region  Services related region

  private fetchPois() {
    const selectedPoi = this.selectedPoi;
    this.selectedPoi = null;
    this.poiQuery.param!.isShowSharedPoI = !this.poiQuery.param!.isUserPOIOnly;
    this.poiQuery.param!.historyMinDate = this.dateFrom;
    this.poiQuery.param!.historyMaxDate = this.dateTo;
    this.service.getPoisPOST(this.poiQuery)
        .then(data => {
          this.pois.splice(0);
          this.pois.push(...data);

          //reselect poi
          if (selectedPoi) {
            const found = this.pois.find(poi => poi.id === selectedPoi.id);
            if (found) {
              this.onPoIClicked(found);
            }
          }
        });
  }

  onEditItem(poi: BasePoI) {
    this.selectedPoiEdit = true;
  }

  onDeleteItem(poi: BasePoI) {
    const result = window.confirm('Are you sure you want to delete PoI ' + poi.name);
    if (result) {
      this.deleteSelected();
    }
  }

  // private addMarker() {
  //   console.log("Add marker");
  //   this.selectedPoiEdit = true;
  //   this.selectedPoi = new BasePoI();
  //   const lngLat = this.mapPopup.getLngLat();
  //   this.selectedPoi.latitude = lngLat.lat;
  //   this.selectedPoi.longitude = lngLat.lng;
  //   const p = new MapPoint();
  //   p.id = "";
  //   p.type = TypePOI.Waterpoint;
  //   p.center = lngLat;
  //   p.custom = true;
  //   p.draggable = false;
  //   this.markers.push(p);
  //   this.mapPopup.remove();
  // }

  poiSelectedInSearch(sPoi) {
    console.log(sPoi);
    (this.$refs.map as MapWithMarkers).zoomInto(new LngLat(sPoi.longitude, sPoi.latitude), 17);
  }

  /**
   * editable
   */
  // private addPopup(lngLat: LngLat) {
  //   if (this.map) {
  //     console.log(lngLat);
  //     const addSpan = document.createElement('span');
  //     addSpan.innerText = this.$i18n.t('btnEdit').toString(); // addSpan.innerHTML = "" also possible
  //     addSpan.onclick = this.addMarker;
  //     const el = document.createElement('div');
  //     el.className = 'context-menu';
  //     el.appendChild(addSpan);
  //     this.mapPopup = new mapboxgl.Popup({ closeOnClick: false })
  //         .setLngLat(lngLat)
  //         .setDOMContent(el)
  //         .addTo(this.map);
  //   }
  // }

  onPoIClicked(poi: BasePoI): void {
    this.selectedPoi = poi;
    this.selectedPoiEdit = false;
  }

  deleteSelected() {
    // if (this.selectedIndex.id !== undefined && this.selectedIndex.id !== "")
    //     this.service.deletePoI(this.selectedIndex.id);
    // this.fetchAndClear();
  }

  @Watch('dateFrom')
  @Watch('dateTo')
  private onDatesChanged(newValue: Date, oldValue: Date): void {
    if (newValue === oldValue) {
      return;
    }

    this.fetchPois();
  }
}
